var _g, _g2, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTextBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 556,
    height: 131,
    viewBox: "0 0 556 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_150)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.68604,
    y: 0.154541,
    width: 550,
    height: 95,
    rx: 16,
    transform: "rotate(3.74182 6.68604 0.154541)",
    fill: "#6A1F3B"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 550,
    height: 95,
    rx: 16,
    transform: "matrix(-0.997868 0.0652607 0.0652607 0.997868 549.828 0)",
    fill: "#6A1F3B"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_18_150)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.68604,
    y: 0.154541,
    width: 550,
    height: 95,
    rx: 16,
    transform: "rotate(3.74182 6.68604 0.154541)",
    fill: "#E77E23"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 550,
    height: 95,
    rx: 16,
    transform: "matrix(-0.997868 0.0652607 0.0652607 0.997868 549.828 0)",
    fill: "#E77E23"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 18,
    width: 550,
    height: 95,
    rx: 16,
    fill: "#FEFEFE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_150"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 280,
    height: 131,
    fill: "white",
    transform: "translate(276)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_18_150"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 276,
    height: 131,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextBackground);
export default __webpack_public_path__ + "static/media/text_background.28dea44cf209349042e78f32e9152185.svg";
export { ForwardRef as ReactComponent };